import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "message-page",
  "dark-class": "message-page-dark"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "head-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-box" }, "消息")
], -1)
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "classify-box" }
const _hoisted_5 = { class: "menu-box" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "所有", -1)
const _hoisted_7 = { class: "count" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "未读消息", -1)
const _hoisted_9 = { class: "count unread" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "count" }
const _hoisted_13 = ["uuid", "onClick"]
const _hoisted_14 = { class: "type-box" }
const _hoisted_15 = { class: "info-box" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "info" }
const _hoisted_18 = { class: "date-box" }
const _hoisted_19 = { class: "operating-box" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "empty"
}
const _hoisted_22 = { class: "icon" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "暂无未读消息", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_comp_entity = _resolveComponent("comp-entity")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["item-box", { activity: this.menuActivity === 'ALL' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeMenuActivity('ALL')))
          }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.allCount), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["item-box", { activity: this.menuActivity === 'UNREAD' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeMenuActivity('UNREAD')))
          }, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.unreadCount), 1)
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item-box", { activity: this.menuActivity === item.source.name }]),
              key: idx,
              onClick: ($event: any) => (_ctx.onChangeMenuActivity(item.source.name))
            }, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(item.source.title), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.count), 1)
            ], 10, _hoisted_10))
          }), 128))
        ])
      ]),
      _createElementVNode("div", {
        class: "message-box",
        onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
        ref: "message_box"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["message-item", { 'message-unread': item.readStatus === 0 }]),
            key: item.uuid,
            uuid: item.uuid,
            onClick: ($event: any) => (_ctx.onOpenEntity(item.uuid))
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_elem_icon, {
                width: "25px",
                height: "25px",
                src: "static/interactive/icon/",
                name: _ctx.getMessageIcon(item.type),
                dark: _ctx.getMessageIcon(item.type, true)
              }, null, 8, ["name", "dark"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.source.title), 1),
              _createElementVNode("div", _hoisted_17, _toDisplayString(item.message), 1)
            ]),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.dateToString(item.createdDate)), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "icon",
                onClick: _withModifiers(($event: any) => (_ctx.onDelete(item.uuid)), ["stop"])
              }, [
                _createVNode(_component_elem_icon, {
                  name: "close",
                  dark: "close_white"
                })
              ], 8, _hoisted_20)
            ])
          ], 10, _hoisted_13))
        }), 128)),
        (_ctx.messages && _ctx.messages.length <= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_elem_icon, {
                  width: "18px",
                  height: "18px",
                  src: "static/interactive/message/icon/",
                  name: "success",
                  dark: "success_dark"
                })
              ]),
              _hoisted_23
            ]))
          : _createCommentVNode("", true)
      ], 544),
      _createVNode(_component_comp_entity, {
        ref: "comp_entity",
        name: "Message",
        title: "消息"
      }, null, 512)
    ])
  ]))
}